import * as Types from '../Constants/AllConstants';

// ==================== LEAGUE REDUCERS ====================

// Get all leagues
export const GetAllLeaguesReducer = (
  state = { leagues: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.LEAGUE_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.LEAGUE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        leagues: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.LEAGUE_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.LEAGUE_LIST_RESET:
      return { leagues: [] };
    default:
      return state;
  }
};

// League details
export const LeagueDetailsReducer = (state = { league: {} }, action) => {
  switch (action.type) {
    case Types.LEAGUE_DETAILS_REQUEST:
      return { loading: true };
    case Types.LEAGUE_DETAILS_SUCCESS:
      return { loading: false, league: action.payload };
    case Types.LEAGUE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create league
export const CreateLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.LEAGUE_CREATE_REQUEST:
      return { loading: true };
    case Types.LEAGUE_CREATE_SUCCESS:
      return { loading: false, success: true, league: action.payload };
    case Types.LEAGUE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.LEAGUE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update league
export const UpdateLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.LEAGUE_UPDATE_REQUEST:
      return { loading: true };
    case Types.LEAGUE_UPDATE_SUCCESS:
      return { loading: false, success: true, league: action.payload };
    case Types.LEAGUE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.LEAGUE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete league
export const DeleteLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.LEAGUE_DELETE_REQUEST:
      return { loading: true };
    case Types.LEAGUE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.LEAGUE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.LEAGUE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};


